import { createReducer } from 'redux-act';

import {
  SITES_FETCH_DATA_INIT,
  SITES_FETCH_DATA_SUCCESS,
  SITES_FETCH_DATA_FAIL,
  SITES_DELETE_SITE_INIT,
  SITES_DELETE_SITE_SUCCESS,
  SITES_DELETE_SITE_FAIL,
  SITES_CLEAR_DATA,
  SITES_CREATE_SITE_INIT,
  SITES_CREATE_SITE_SUCCESS,
  SITES_CREATE_SITE_FAIL,
  SITES_MODIFY_SITE_INIT,
  SITES_MODIFY_SITE_SUCCESS,
  SITES_MODIFY_SITE_FAIL,
  SITES_CLEAN_UP,
  SITES_CLEAR_DATA_LOGOUT,
} from 'state/actions/sites';

const initialState = {
  list: [],
  site: {
    name: '',
    description: '',
    playlist: '',
    organizationId: '',
    organizationName: '',
    modifiedAt: new Date().toDateString(),
    modifiedBy: '',
  },
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const sitesReducer = createReducer(
  {
    [SITES_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true,
    }),
    [SITES_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.list || [],
      site: payload.site || initialState.site,
      loading: false,
      error: null,
    }),
    [SITES_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SITES_DELETE_SITE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SITES_DELETE_SITE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((elem) => elem.id !== payload.id),
      loading: false,
      error: null,
      deleted: true,
    }),
    [SITES_DELETE_SITE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SITES_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [SITES_CREATE_SITE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SITES_CREATE_SITE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.concat(payload.site),
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [SITES_CREATE_SITE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SITES_MODIFY_SITE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SITES_MODIFY_SITE_SUCCESS]: (state, payload) => ({
      ...state,
      list: !state.list
        ? []
        : state.list.map((elem) => {
            if (elem.id === payload.id) {
              return {
                name: payload.site.name,
                description: payload.site.description,
                organizationId: payload.site.organizationId,
                organizationName: payload.site.organizationName,
                modifiedAt: new Date().toDateString(),
                modifiedBy: elem.email,
              };
            }
            return elem;
          }),
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [SITES_MODIFY_SITE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SITES_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
      updated: false,
    }),
    [SITES_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
  },
  initialState
);
